import { isNonEmptyString } from '@/utils/checks'
import type { PageType } from '@/types/models'
import * as PageTypeChecks from '@/domain/useCases/pageTypeCheck'

const shouldUseNewUI = (pageType: PageType): boolean => {
  return (
    isNonEmptyString(pageType) &&
    (PageTypeChecks.isLocationPageType(pageType) ||
      PageTypeChecks.isInsurancePageType(pageType) ||
      PageTypeChecks.isInsuranceFacetPageType(pageType) ||
      PageTypeChecks.isClientelePageType(pageType) ||
      PageTypeChecks.isClienteleFacetPageType(pageType) ||
      PageTypeChecks.isLevelsOfCarePageType(pageType) ||
      PageTypeChecks.isLevelsOfCareFacetPageType(pageType) ||
      PageTypeChecks.isAcceptedInsuranceFacetPageType(pageType) ||
      PageTypeChecks.isTherapyPageType(pageType) ||
      PageTypeChecks.isTherapyFacetPageType(pageType) ||
      PageTypeChecks.isPricePageType(pageType) ||
      PageTypeChecks.isPriceFacetPageType(pageType) ||
      PageTypeChecks.isApproachPageType(pageType) ||
      PageTypeChecks.isApproachFacetPageType(pageType) ||
      PageTypeChecks.isSettingPageType(pageType) ||
      PageTypeChecks.isSettingFacetPageType(pageType) ||
      PageTypeChecks.isActivitiesPageType(pageType) ||
      PageTypeChecks.isActivitiesFacetPageType(pageType) ||
      PageTypeChecks.isAmenitiesPageType(pageType) ||
      PageTypeChecks.isAmenitiesFacetPageType(pageType) ||
      PageTypeChecks.isSpecialConsiderationsPageType(pageType) ||
      PageTypeChecks.isSpecialConsiderationsFacetPageType(pageType) ||
      PageTypeChecks.isConditionPageType(pageType) ||
      PageTypeChecks.isConditionFacetPageType(pageType))
  )
}

export default shouldUseNewUI
